import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["value", "onChange", "isDisabled"];
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import Flex, { Box } from 'components/Flex';
import CheckboxOption from 'components/CheckboxOption';
import Button from 'components/Button';
import ContentContributionsModal from 'screens/ContentContributionModal';
function MemberContributionsInfoButton(_ref) {
  var labelId = _ref.labelId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentContributionModalOpen = _useState2[0],
    setContentContributionModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    icon: "info",
    variant: "transparent",
    onClick: function onClick() {
      return setContentContributionModalOpen(true);
    },
    size: "small",
    "aria-describedby": labelId
  }, t('actions_info')), isContentContributionModalOpen && /*#__PURE__*/React.createElement(ContentContributionsModal, {
    onClose: function onClose() {
      return setContentContributionModalOpen(false);
    }
  }));
}
export function MemberContributionsCheckbox(_ref2) {
  var isDisabled = _ref2.isDisabled,
    _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked,
    id = _ref2.id,
    onChange = _ref2.onChange;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    mr: "auto"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('hint_member_contributions'),
    checked: checked,
    onChange: onChange,
    id: id,
    disabled: isDisabled
  })), !isDisabled && /*#__PURE__*/React.createElement(MemberContributionsInfoButton, {
    labelId: id
  }));
}
function MemberContributionsField(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange,
    isDisabled = _ref3.isDisabled,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var checkboxId = useUniqueId();
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_user_created_assets')
  }, otherProps), /*#__PURE__*/React.createElement(MemberContributionsCheckbox, {
    isDisabled: isDisabled,
    checked: value,
    id: checkboxId,
    onChange: onChange
  }));
}
export default MemberContributionsField;